export const lang = {
    login:{
        title: 'Login om verder te gaan',
        emailLabel: 'E-mail adres',
        emailPlaceholder: 'Vul e-mail adres',
        emailError: 'E-mail is verplicht',
        passwordLabel: 'Wachtwoord',
        passwordPlaceholder: 'Vul wachtwoord',
        passwordError: 'Wachtwoord is verplicht',
        login: 'Inloggen',
        forgotPassword: 'Wachtwoord vergeten?'
    },
    forgotPassword:{
        title: 'Wachtwoord reset',
        emailLabel: 'E-mail adres',
        emailPlaceholder: 'Vul e-mail adres',
        emailError: 'E-mail is verplicht',
        forgotPasswordBtn: 'Wachtwoord opnieuw instellen',
        backToLogin: 'Terug naar Inloggen'
    },
    recoverPassword:{
        title:'Nieuw wachtwoord invoeren',
        passwordHelperText: 'Wachtwoord dient langer te zijn dan 3 karakters.',
        passwordLabel: 'Wachtwoord',
        passwordPlaceholder: 'Vul wachtwoord',
        passwordError: 'Wachtwoord benodigd',
        repeatPasswordLabel: 'Herhaal wachtwoord',
        repeatPasswordPlaceholder: 'Herhaal wachtwoord',
        repeatPasswordError: 'Wachtwoord komt het meest overeen',
        recoverPasswordBtn: 'Wachtwoord opnieuw instellen'
    },
    activateAccount:{
        title:'Activeer account',
        nameLabel: 'E-mail',
        namePlaceholder: 'Vul naam',
        nameError: 'Naam benodigd',
        passwordHelperText: 'Wachtwoord dient langer te zijn dan 3 karakters.',
        passwordLabel: 'Wachtwoord',
        passwordPlaceholder: 'Vul wachtwoord',
        passwordError: 'Wachtwoord benodigd',
        repeatPasswordLabel: 'Herhaal wachtwoord',
        repeatPasswordPlaceholder: 'Herhaal wachtwoord',
        repeatPasswordError: 'Wachtwoord komt het meest overeen',
        activateAccountBtn: 'Activeer account'
    },
    nav:{
        workers: 'Werknemers',
        clients: 'Klanten',
        projects: 'Projecten',
        seals: 'Afdichtingen',
        qr: 'QR-codes afdrukken'
    },
    header:{
        logout: 'Uitloggen',
        build: 'Build'
    },
    common: {
        switch: 'Wissel actief/inactief',
        file: 'Bestanden',
        edit: 'Aanpassen',
        delete: 'Verwijderen',
        show: 'Toon Klantprojecten',
        map: 'Map',
        contacts: 'Gekoppelde gebruiker',
        check: 'Verander status',
        info: "Meer info"
    },
    projects: {
        add: 'Project toevoegen',
        globe: 'Plattegronden',
        viewProjectPage: 'Toon project pagina'
    },
    employee: {
        add: 'Werknemers toevoegen',
        globe: 'Plattegronden',
        viewProjectPage: 'Toon project pagina'
    },
    customer: {
        add: 'Klant toevoegen',
        globe: 'Plattegronden',
        viewProjectPage: 'Toon project pagina'
    }
}
